export const AgentRoleEnum = {
  SaleListingAgent:
  {
    key: 1,
    name: 'Sale Listing Agent',
    value: '75B469D7-2C6E-49EC-8F3B-0995F22AB259'

  },
  LeaseListingAgent: {
    key: 2,
    name: 'Lease Listing Agent',
    value: 'e1c2f1c5-402b-4efc-b3aa-237d1d8868ac',

  },
  SaleAgent: {
    key: 3,
    name: 'Sale Agent',
    value: '01e1686c-858d-411b-8560-3ce8d3f7e0a2',

  },
  LeaseAgent: {
    key: 4,
    name: 'Lease Agent',
    value: '0F056FBE-C702-4F1F-927A-65F923D8A258',

  },
};
